// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'jquery'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import 'font-awesome/css/font-awesome.css'

import Vue from 'vue'
import i18n from '@/utils/i18n'

import App from './App'
import router from './router'
import store from '@/store/store.js'
import AuthService from '@/utils/authService'

import { mapGetters } from 'vuex'

import veeFr from 'vee-validate/dist/locale/fr'
import veeEn from 'vee-validate/dist/locale/en'
import VeeValidate, { Validator } from 'vee-validate'
import VueLazyload from 'vue-lazyload'

import Sortable from 'sortablejs'
import VueCookie from 'vue-cookie'
import VueTextareaAutosize from 'vue-textarea-autosize'

import Sync from '@/utils/sync'
import AppWire from '@/utils/appwire'

Vue.config.productionTip = true

Validator.localize('fr', veeFr)
Validator.localize('en', veeEn)

Vue.use(VeeValidate, {
  locale: 'en',
  dictionary: {
    fr: {
      // messages: messagesVeeValidateFr,
      attributes: {
        email: 'Email',
        login: 'Login',
        firstname: 'Prénom',
        lastname: 'Nom de famille',
        birthday: 'Date de naissance',
        oldPassword: 'Ancien mot de passe',
        newPassword: 'Nouveau mot de passe',
        confNewPassword: 'Confirmation du nouveau mot de passe'
      },
      messages: {

      }
    },
    en: {
      // messages: messagesVeeValidateFr,
      attributes: {
        email: 'Email',
        login: 'Login',
        firstname: 'Firstname',
        lastname: 'Lastname',
        birthday: 'Birthday',
        oldPassword: 'Current password',
        newPassword: 'New password',
        confNewPassword: 'New password confirmation'
      },
      messages: {

      }
    }
  }
})

Vue.use(VueLazyload, {
  observer: true,
  preLoad: 1.3,
  error: '/static/notFound.jpg'
})

const synchronize = new Sync()
const syncPlugin = {
  install (Vue, options) {
    Vue.mixin({
      created () {
        this.$synchronize = synchronize
      }
    })
  }
}
document.documentElement.className += (('ontouchstart' in document.documentElement) ? ' touch' : ' no-touch')
Vue.use(syncPlugin)

const appwireBus = new Vue({ name: 'appwireBus' })

const appwire = new AppWire({appid: 'groopus', server: 'https://appwire.groopus.com/', port: ''})
const appwirePlugin = {
  install (Vue, options) {
    Vue.mixin({
      created () {
        this.$appwire = appwire
        this.$appwireEvents = appwireBus
      }
    })
  }
}

Vue.use(appwirePlugin)

Vue.directive('sortable', {
  inserted: function (el, binding) {
    /* eslint-disable no-new */
    new Sortable(el, binding.value || {})
  }
})

Vue.use(VueCookie)

Vue.use(VueTextareaAutosize)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
  computed: {
    ...mapGetters('user', [
      'user',
      'isConnected'
    ])
  },
  mounted () {
    let userLang = this.$route.query.lang
    if (!userLang) {
      userLang = this.$cookie.get('lg')
    }
    if (!userLang) {
      userLang = navigator.language || navigator.userLanguage
    }
    this.$i18n.changeLocale(userLang.substring(0, 2), this)
    // console.log(this)
    AuthService.onTokenChange(() => {
      this.$store.dispatch('user/tokenChange').then(() => {
        this.manageConnection()
      })
    })
    this.$store.dispatch('user/initFromStorage').then(() => {
      if (!this.isConnected && this.$route.meta.needConnected) {
        this.manageConnection()
      }
    })
  },
  methods: {
    manageConnection () {
      if (!this.isConnected) {
        this.$store.dispatch('storeClean')
        if (this.$route.meta.needConnected && this.$route.fullPath !== '/') {
          this.$router.push({ name: 'NeedConnection', query: { nextUrl: this.$route.fullPath } })
        }
      }
    }
  },
  watch: {
    user () {
      this.$store.dispatch('groops/reload')
      if (this.user) {
        this.$i18n.changeLocale(this.user.lg, this)
      }
    },
    $route () {
      this.manageConnection()
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js